import { Box, BoxExtendedProps } from 'grommet'
import { PropsWithChildren } from 'react'

import useDeviceSize from 'hooks/useDevice'

export default function PlotBox({
  children,
  ...additionallProps
}: PropsWithChildren<BoxExtendedProps>) {
  const { small } = useDeviceSize()
  return (
    <Box
      gap="small"
      align="left"
      round="xsmall"
      fill="horizontal"
      alignSelf="center"
      background={{ color: 'white', opacity: 'strong' }}
      pad={{
        horizontal: small ? 'large' : 'medium',
        vertical: small ? 'large' : 'small',
      }}
      {...additionallProps}>
      {children}
    </Box>
  )
}
